import React, { PureComponent } from 'react'
import styled from 'styled-components'
import colors from 'modules/common/components/ui/colors';
import classNames from 'classnames'

const List = styled.ul`
  max-height: ${({maxVisibleRows = 4}) => 53 * maxVisibleRows / 16}rem;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  position: absolute;
  left: 0;
  width: 100%;
  padding: 0;
  background: white;
  color: ${colors.GRAY_DARK};
  font-size: calc(18rem / 16);
  line-height: 2rem;
  text-align: left;
  z-index: 1;
  margin-top: ${(props) => props.theme.AutoComplete_ResultList_marginTop};
  top: 100%;
  border: 1px solid ${(props) => props.theme.AutoComplete_ResultList_border_color};
  font-size: calc(18rem / 16);
  box-shadow: 0 1px 12px 0 rgba(0,0,0,0.15);
  scroll-behavior: smooth;
  li {
    background: transparent;
    display: block;
    padding: calc(10rem / 16) calc(18rem / 16);
    border-top: 1px solid ${(props) => props.theme.AutoComplete_ResultList_border_color};
    cursor: pointer;
    &:focus{
      outline: none;
      background: ${colors.GRAY_MEGA_LIGHT};
    }
    &:first-child{
      border-top: none;
    }
    &:hover {
      background: ${colors.GRAY_MEGA_LIGHT};
    }
    &.active {
      background: ${colors.GRAY_MEGA_LIGHT};
    }
  }
`



class SuggestionList extends PureComponent {
  _isMounted = false

  state = {
    selectedIndex: 0,
    hidden: false,
  }

  componentDidMount() {
    if (document && document.addEventListener) {
      document.addEventListener('keydown', this.handleKeys);
    }
    this._isMounted = true
  }

  componentWillUnmount() {
    if (document && document.removeEventListener) {
      document.removeEventListener('keydown', this.handleKeys);
    }
    this._isMounted = false
  }

  componentWillReceiveProps(nextProps) {
    const {
      items = []
    } = nextProps
    if(items.length){
      this.show()
    }
  }

  componentDidUpdate(prevProps, prevState){
    const {
      selectedIndex: previousSelectedIndex
    } = prevState
    const {
      selectedIndex
    } = this.state
    if(selectedIndex !== previousSelectedIndex && this.list){ // scroll item if necessary
      const el = this.list.querySelector(`li:nth-child(${selectedIndex})`)
      if(el){
        if(el.offsetTop + el.clientHeight > this.list.clientHeight + this.list.scrollTop){
          this.list.scrollTo(0,el.offsetTop)
        }
        else if(el.offsetTop < this.list.scrollTop){
          this.list.scrollTo(0,el.offsetTop)
        }
      }
    }
  }

  show = () => {
    if(!this._isMounted){
      return
    }
    this.setState({
      hidden: false,
    })
  }
  
  hide = () => {
    if(!this._isMounted){
      return
    }
    this.setState({
      hidden: true,
    })
  }

  handleKeys = (event) => {
    if(!this._isMounted){
      return
    }
    switch (event.keyCode) {
      case 13: // Enter
        this.handleSelect(event)
        this.hide()
        break
      case 27:
        break
      case 38:
        event.preventDefault()
        this.selectPrevious()
        break;
      case 40:
        event.preventDefault()
        this.selectNext()
        break
      default:
        break
    }
  }
  
  handleSelect = (event) => {
    const {
      selectedIndex,
    } = this.state
    const {
      items,
      onChange,
    } = this.props

    if(selectedIndex && selectedIndex > 0){
      event.preventDefault();
      onChange(items[selectedIndex - 1])
    }
  }

  selectPrevious = () => {
    if(!this._isMounted){
      return
    }
    const {
      selectedIndex,
    } = this.state
    const {
      items = [],
    } = this.props

    if(selectedIndex < 2){
      this.setState({
        selectedIndex: items.length
      })
    }
    else{
      this.setState({
        selectedIndex: selectedIndex-1
      })
    }
  }

  selectNext = () => {
    if(!this._isMounted){
      return
    }
    const {
      selectedIndex,
    } = this.state

    const {
      items = [],
    } = this.props
    if(items.length === selectedIndex){
      this.setState({
        selectedIndex: 1
      })
    }
    else{
      this.setState({
        selectedIndex: selectedIndex+1
      })
    }
  }

  focus = () => {
    const {
      selectedIndex
    } = this.state
    
    if(this.list){
      const el = this.list.querySelector(`li:nth-child(${selectedIndex})`)
      if(el){
        if(el.offsetTop + el.clientHeight < this.list.clientHeight){
          this.list.style['overflow-y'] = 'hidden'
        }
        else{
          this.list.style['overflow-y'] = 'scroll'
        }
        el.focus()
      }
    }
  }

  resetSelectedIndex = () => {
    if(!this._isMounted){
      return
    }

    this.setState({
      selectedIndex: 0
    })
  }
  
  render() {
    const {
      items = [],
      onChange,
    } = this.props
    const {
      selectedIndex,
      hidden,
    } = this.state
    if(hidden || items.length === 0){
      return null
    }
    return (
      <List
        innerRef={el => this.list = el}
      >
        { items.map((item, index) => <li className={classNames({'active': (index + 1 === selectedIndex)})} key={item} onClick={() => onChange(item)} tabIndex="0" role="button">{item}</li> ) }
      </List>
    )
  }
}

export default SuggestionList



// WEBPACK FOOTER //
// ./src/modules/search/components/SuggestionList.js